module.exports = __webpack_public_path__ + "img/sms-logo-min.29f4b488.png";